export default __webpack_public_path__ + "static/media/logo.13942bff.svg";